<template>
  <div>
    <template v-if="showCarousel">
      <carousel selector=".carousel-wrapper" variant="show1">
        <section class="carousel component standard">
          <div class="carousel-wrapper show1">
            <slot></slot>
          </div>
        </section>
      </carousel>
    </template>
    <template v-else >
      <slot></slot>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "carousel-converter",
  props: {
    breakpoints: {
      type: Array,
      required: false,
      default: () => {
        return ['xs', 'sm'];
      },
    },
    enabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapGetters("responsive", ["currentBreakpoint"]),
    showCarousel() {
      return this.breakpoints.includes(this.currentBreakpoint) && this.enabled;
    },
  },
};
</script>

<style>
</style>